import {useMemo} from 'react'
import useQueryVolumeLeague from './useQueryVolumeLeague'
import {IVolumeLeagueItem} from '../../../apis/volume_league/get'
import {ITraderMapCampaign} from '../../../apis/tradermap_campaign/list'

/**
 * 임시: admin/trader/campaigns 대체.
 * 공개 volume-league 를 group_key(같은 심볼) 단위로 묶고, 각 그룹의 competition 리그만 골라
 * 기존 ITraderMapCampaign 형태로 변환한다. id 는 league id(문자열).
 */
const toCampaign = (league: IVolumeLeagueItem): ITraderMapCampaign => ({
    id: String(league.id),
    title: {en: league.name, ko: league.name},
    symbol: league.symbol || league.group_label,
    priority: league.sort_value ?? 0,
    status: league.status,
    symbol_image: league.logo,
    exchanges: league.exchange_urls ?? {},
    start_at: league.start_at,
    end_at: league.end_at,
    prize_pool: league.prize_pool,
    url_third_party: league.url_third_party,
    created_at: league.created_at,
    updated_at: league.updated_at,
})

const useQueryVolumeLeagueCampaign = () => {
    const {data: leagues, refetch} = useQueryVolumeLeague()

    const data = useMemo(() => {
        if (!leagues) return undefined
        const groups = new Map<string, IVolumeLeagueItem[]>()
        leagues.forEach(league => {
            const key = league?.group_key || `sym:${league?.symbol}`
            groups.set(key, [...(groups.get(key) || []), league])
        })
        return Array.from(groups.values())
            .flatMap(group => group.filter(league => league?.kind === 'competition'))
            .map(toCampaign)
    }, [leagues])

    return {data: data, refetch}
}

export default useQueryVolumeLeagueCampaign
